import { useNavigate, Link } from "react-router-dom";
import DashboardSectionCard from "./DashboardSectionCard";
import EmptyState from "./EmptyState";

const fmtDate = (d) => {
  if (!d) return "";
  return new Date(d.replace(/-/g, "/")).toLocaleDateString("en-US", { month:"short", day:"numeric" });
};

const STAGES = [
  { key: "shortlisted_count", label: "Shortlisted", color: "#2563EB", bg: "var(--fc-primary-light)" },
  { key: "interview_count",   label: "Interview",   color: "#D97706", bg: "var(--fc-amber-light)"   },
  { key: "presented_count",   label: "Presented",   color: "#16A34A", bg: "var(--fc-green-light)"    },
];

export default function JobPipelineSnapshot({ jobs = [], loading }) {
  const navigate = useNavigate();

  return (
    <DashboardSectionCard title="Jobs Needing Attention" subtitle="Stalled jobs first, then most recent" icon="fa-diagram-project" colorKey="amber"
      action={jobs.length > 0
        ? <Link to="/jobs" style={{fontSize:12,fontWeight:600,color:"var(--fc-primary)",textDecoration:"none"}}>View all &rarr;</Link>
        : null}>
      {loading ? (
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          {[1,2,3].map(i => (
            <div key={i} style={{ background:"var(--fc-bg-light)", borderRadius:10, padding:"13px 15px" }}>
              <div style={{ height:12, background:"var(--fc-border-light)", borderRadius:4, width:"45%", marginBottom:8 }} />
              <div style={{ height:9, background:"var(--fc-border-light)", borderRadius:4, width:"70%" }} />
            </div>
          ))}
        </div>
      ) : !jobs.length ? (
        <EmptyState icon="fa-diagram-project" text="No open jobs" sub="Posted jobs and their pipeline will show up here" />
      ) : (
        <div className="fc-scroll-container" style={{ overflowY:"auto", overflowX:"hidden", maxHeight:280, scrollbarWidth:"none" }}>
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {jobs.map((j, i) => {
              const isStalled = String(j.is_stalled) === "1";
              const total = Number(j.candidates_count) || 0;
              return (
                <div key={j.job_id || i}
                  onClick={() => navigate(`/job/details/${j.job_slug}`)}
                  style={{ background:"var(--fc-bg-light)", border:`1px solid ${isStalled ? "var(--fc-red-border)" : "var(--fc-border-light)"}`, borderRadius:10, padding:"12px 15px", cursor:"pointer", transition:"all 0.15s" }}
                  onMouseEnter={e=>{ e.currentTarget.style.background="var(--fc-primary-light)"; }}
                  onMouseLeave={e=>{ e.currentTarget.style.background="var(--fc-bg-light)"; }}>

                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:8, gap:8 }}>
                    <span style={{ fontSize:13, fontWeight:700, color:"var(--fc-text-primary)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                      {j.job_title}
                    </span>
                    {isStalled && (
                      <span style={{ fontSize:10, fontWeight:700, color:"var(--fc-red)", background:"var(--fc-red-light)", padding:"2px 8px", borderRadius:99, flexShrink:0, display:"flex", alignItems:"center", gap:4 }}>
                        <i className="fa-solid fa-triangle-exclamation" style={{fontSize:9}} />Stalled
                      </span>
                    )}
                  </div>

                  {total === 0 ? (
                    <div style={{ fontSize:11.5, color:"var(--fc-text-subtle)" }}>No candidates yet</div>
                  ) : (
                    <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
                      {STAGES.map(s => (
                        Number(j[s.key]) > 0 && (
                          <div key={s.key} style={{ display:"flex", alignItems:"center", gap:5 }}>
                            <div style={{ width:6, height:6, borderRadius:"50%", background:s.color, flexShrink:0 }} />
                            <span style={{ fontSize:11.5, color:"var(--fc-text-secondary)" }}>{j[s.key]} {s.label}</span>
                          </div>
                        )
                      ))}
                    </div>
                  )}

                  {j.last_activity && (
                    <div style={{ fontSize:10.5, color:"var(--fc-text-hint)", marginTop:6 }}>
                      Last activity {fmtDate(j.last_activity)}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </DashboardSectionCard>
  );
}